import React, { useState } from 'react';
import { UserIcon, ShieldIcon, KeyIcon, FilterIcon, DownloadIcon } from 'lucide-react';
export function IntegrationsAuditTab() {
  const [selectedFilter, setSelectedFilter] = useState('all');
  const auditLogs = [{
    id: 1,
    timestamp: '2024-01-20 14:55',
    user: 'Sarah Chen',
    action: 'Connection Created',
    resource: 'Salesforce Production',
    details: 'Created new Salesforce connection with read/write access',
    ip: '192.168.1.100',
    severity: 'info'
  }, {
    id: 2,
    timestamp: '2024-01-20 14:30',
    user: 'Mike Rodriguez',
    action: 'Sync Started',
    resource: 'HubSpot Contacts Import',
    details: 'Manual sync triggered for 892 contacts',
    ip: '192.168.1.105',
    severity: 'info'
  }, {
    id: 3,
    timestamp: '2024-01-20 13:15',
    user: 'System',
    action: 'Authentication Failed',
    resource: 'Marketo',
    details: 'API authentication failed - invalid credentials',
    ip: 'N/A',
    severity: 'warning'
  }, {
    id: 4,
    timestamp: '2024-01-20 11:00',
    user: 'Lisa Park',
    action: 'Permission Changed',
    resource: 'Google Ads',
    details: 'Updated permissions to read-only access',
    ip: '192.168.1.112',
    severity: 'warning'
  }, {
    id: 5,
    timestamp: '2024-01-20 09:30',
    user: 'Sarah Chen',
    action: 'Connection Deleted',
    resource: 'Salesforce Sandbox Old',
    details: 'Removed deprecated sandbox connection',
    ip: '192.168.1.100',
    severity: 'critical'
  }, {
    id: 6,
    timestamp: '2024-01-19 16:45',
    user: 'Mike Rodriguez',
    action: 'Field Mapping Updated',
    resource: 'Salesforce Production',
    details: 'Modified field mapping for Account.Industry',
    ip: '192.168.1.105',
    severity: 'info'
  }, {
    id: 7,
    timestamp: '2024-01-19 14:20',
    user: 'System',
    action: 'Sync Completed',
    resource: 'Marketo Leads Export',
    details: 'Successfully synced 3,421 leads',
    ip: 'N/A',
    severity: 'info'
  }, {
    id: 8,
    timestamp: '2024-01-19 10:00',
    user: 'Lisa Park',
    action: 'API Key Rotated',
    resource: 'HubSpot',
    details: 'API key rotated for security compliance',
    ip: '192.168.1.112',
    severity: 'warning'
  }];
  const permissions = [{
    user: 'Sarah Chen',
    role: 'Admin',
    connections: ['All'],
    canCreate: true,
    canEdit: true,
    canDelete: true,
    lastActive: '5 minutes ago'
  }, {
    user: 'Mike Rodriguez',
    role: 'Manager',
    connections: ['Salesforce', 'HubSpot', 'Marketo'],
    canCreate: true,
    canEdit: true,
    canDelete: false,
    lastActive: '1 hour ago'
  }, {
    user: 'Lisa Park',
    role: 'Operator',
    connections: ['Google Ads', 'LinkedIn Ads'],
    canCreate: false,
    canEdit: true,
    canDelete: false,
    lastActive: '2 hours ago'
  }, {
    user: 'John Smith',
    role: 'Viewer',
    connections: ['All'],
    canCreate: false,
    canEdit: false,
    canDelete: false,
    lastActive: '1 day ago'
  }];
  const getSeverityColor = (severity: string) => {
    switch (severity) {
      case 'critical':
        return 'bg-red-100 text-red-700';
      case 'warning':
        return 'bg-yellow-100 text-yellow-700';
      case 'info':
        return 'bg-blue-100 text-blue-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };
  const filteredLogs = selectedFilter === 'all' ? auditLogs : auditLogs.filter(log => log.severity === selectedFilter);
  return <div className="space-y-6" data-id="element-1468">
      {/* Summary Cards */}
      <div className="grid grid-cols-4 gap-4" data-id="element-1469">
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1470">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1471">Total Events (30d)</p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-1472">2,847</p>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1473">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1474">Active Users</p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-1475">4</p>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1476">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1477">Failed Auth</p>
          <p className="text-3xl font-bold text-red-600" data-id="element-1478">3</p>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1479">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1480">Permission Changes</p>
          <p className="text-3xl font-bold text-yellow-600" data-id="element-1481">12</p>
        </div>
      </div>
      {/* Audit Logs */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-1482">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-1483">
          <div className="flex items-center justify-between" data-id="element-1484">
            <h3 className="text-lg font-semibold text-gray-900" data-id="element-1485">Audit Logs</h3>
            <div className="flex items-center gap-3" data-id="element-1486">
              <div className="flex items-center gap-2" data-id="element-1487">
                <FilterIcon className="w-4 h-4 text-gray-600" data-id="element-1488" />
                <select value={selectedFilter} onChange={e => setSelectedFilter(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-1489">
                  <option value="all" data-id="element-1490">All Events</option>
                  <option value="critical" data-id="element-1491">Critical</option>
                  <option value="warning" data-id="element-1492">Warning</option>
                  <option value="info" data-id="element-1493">Info</option>
                </select>
              </div>
              <button className="flex items-center gap-2 px-3 py-1.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm" data-id="element-1494">
                <DownloadIcon className="w-4 h-4" data-id="element-1495" />
                Export
              </button>
            </div>
          </div>
        </div>
        <div className="divide-y divide-gray-200 max-h-96 overflow-y-auto" data-id="element-1496">
          {filteredLogs.map(log => <div key={log.id} className="p-6 hover:bg-gray-50" data-id="element-1497">
              <div className="flex items-start justify-between mb-2" data-id="element-1498">
                <div className="flex-1" data-id="element-1499">
                  <div className="flex items-center gap-3 mb-2" data-id="element-1500">
                    <span className={`px-2 py-1 rounded text-xs font-medium ${getSeverityColor(log.severity)}`} data-id="element-1501">
                      {log.severity}
                    </span>
                    <span className="text-sm font-semibold text-gray-900" data-id="element-1502">
                      {log.action}
                    </span>
                  </div>
                  <p className="text-sm text-gray-700 mb-2" data-id="element-1503">{log.details}</p>
                  <div className="flex items-center gap-4 text-xs text-gray-600" data-id="element-1504">
                    <span data-id="element-1505">Resource: {log.resource}</span>
                    <span data-id="element-1506">User: {log.user}</span>
                    <span data-id="element-1507">IP: {log.ip}</span>
                  </div>
                </div>
                <span className="text-xs text-gray-600 whitespace-nowrap" data-id="element-1508">
                  {log.timestamp}
                </span>
              </div>
            </div>)}
        </div>
      </div>
      {/* Permissions Table */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1509">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-1510">
          <div className="flex items-center gap-2" data-id="element-1511">
            <ShieldIcon className="w-5 h-5 text-red-600" data-id="element-1512" />
            <h3 className="text-lg font-semibold text-gray-900" data-id="element-1513">
              User Permissions
            </h3>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium" data-id="element-1514">
            <UserIcon className="w-4 h-4" data-id="element-1515" />
            Manage Users
          </button>
        </div>
        <table className="w-full" data-id="element-1516">
          <thead className="bg-gray-50 border-b border-gray-200" data-id="element-1517">
            <tr data-id="element-1518">
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1519">
                User
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1520">
                Role
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1521">
                Connections
              </th>
              <th className="px-6 py-3 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1522">
                Create
              </th>
              <th className="px-6 py-3 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1523">
                Edit
              </th>
              <th className="px-6 py-3 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1524">
                Delete
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1525">
                Last Active
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-1526">
            {permissions.map((permission, index) => <tr key={index} className="hover:bg-gray-50" data-id="element-1527">
                <td className="px-6 py-4" data-id="element-1528">
                  <div className="flex items-center gap-2" data-id="element-1529">
                    <UserIcon className="w-4 h-4 text-gray-400" data-id="element-1530" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-1531">
                      {permission.user}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-1532">
                  <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium" data-id="element-1533">
                    {permission.role}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1534">
                  <span className="text-sm text-gray-700" data-id="element-1535">
                    {permission.connections.join(', ')}
                  </span>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-1536">
                  {permission.canCreate ? <span className="text-green-600" data-id="element-1537">✓</span> : <span className="text-gray-300" data-id="element-1538">✗</span>}
                </td>
                <td className="px-6 py-4 text-center" data-id="element-1539">
                  {permission.canEdit ? <span className="text-green-600" data-id="element-1540">✓</span> : <span className="text-gray-300" data-id="element-1541">✗</span>}
                </td>
                <td className="px-6 py-4 text-center" data-id="element-1542">
                  {permission.canDelete ? <span className="text-green-600" data-id="element-1543">✓</span> : <span className="text-gray-300" data-id="element-1544">✗</span>}
                </td>
                <td className="px-6 py-4" data-id="element-1545">
                  <span className="text-sm text-gray-700" data-id="element-1546">
                    {permission.lastActive}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      {/* Security Settings */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1547">
        <div className="flex items-center gap-2 mb-4" data-id="element-1548">
          <KeyIcon className="w-5 h-5 text-red-600" data-id="element-1549" />
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-1550">
            Security Settings
          </h3>
        </div>
        <div className="space-y-3" data-id="element-1551">
          <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-1552">
            <div data-id="element-1553">
              <p className="text-sm font-medium text-gray-900" data-id="element-1554">
                API Key Rotation
              </p>
              <p className="text-xs text-gray-600" data-id="element-1555">
                Automatically rotate keys every 90 days
              </p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1556">
              <input type="checkbox" className="sr-only peer" checked data-id="element-1557" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-red-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-red-600" data-id="element-1558"></div>
            </label>
          </div>
          <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-1559">
            <div data-id="element-1560">
              <p className="text-sm font-medium text-gray-900" data-id="element-1561">
                IP Whitelisting
              </p>
              <p className="text-xs text-gray-600" data-id="element-1562">
                Restrict API access to approved IPs
              </p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1563">
              <input type="checkbox" className="sr-only peer" data-id="element-1564" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-red-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-red-600" data-id="element-1565"></div>
            </label>
          </div>
          <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-1566">
            <div data-id="element-1567">
              <p className="text-sm font-medium text-gray-900" data-id="element-1568">
                Audit Log Retention
              </p>
              <p className="text-xs text-gray-600" data-id="element-1569">Keep logs for 12 months</p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-1570">
              <input type="checkbox" className="sr-only peer" checked data-id="element-1571" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-red-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-red-600" data-id="element-1572"></div>
            </label>
          </div>
        </div>
      </div>
    </div>;
}